import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { getLightBorder } from 'Components/utils';
import { FDHeadlineText } from '@facet-wealth/design';
import AddItemButtonPicker from './AddItemButtonPicker';

const useStyles = buildUseStyles('Header', (theme) => ({
  root: {
    padding: theme.spacing(1, 2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: theme.heights.standardHeaderHeight,
    alignItems: 'center',
    ...getLightBorder(theme, { bottom: true }),
    marginBottom: theme.spacing(2),
    position: 'sticky',
    top: theme.heights.advisorNavigationHeight,
    backgroundColor: theme.palette.common.white,
    zIndex: 100,
  },
}));

const Header = () => {
  const { pageContentResource } = usePageContentContext();
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
      test={'what-if-item-management-list-main-header'}
    >
      <FDHeadlineText
        value={pageContentResource.attr('name') ?? ''}
      />
      <AddItemButtonPicker />
    </Box>
  );
};

export default Header;
